import {
  CONTRACT_PROGRESS_CONTRACT_LOAD_FAILURE,
  CONTRACT_PROGRESS_CONTRACT_LOAD_REQUEST,
  CONTRACT_PROGRESS_CONTRACT_LOAD_SUCCESS,
} from '@app/store/actionTypes';
import { ContractProgressAction } from '@app/store/contract-progress/actions';

type ContractProgressPdfArrayBufferState = ArrayBuffer | null;

const initialState: ContractProgressPdfArrayBufferState = null;

export default function reducer(
  state: ContractProgressPdfArrayBufferState = initialState,
  action: ContractProgressAction
) {
  switch (action.type) {
    case CONTRACT_PROGRESS_CONTRACT_LOAD_REQUEST:
    case CONTRACT_PROGRESS_CONTRACT_LOAD_FAILURE:
      return initialState;
    case CONTRACT_PROGRESS_CONTRACT_LOAD_SUCCESS:
      return action.payload.pdfArrayBuffer;
    default:
      return state;
  }
}
